// @ts-nocheck
// tslint:disable
import { HTMLElement } from './HTMLElement';

export class HTMLMediaElement extends HTMLElement {
  constructor(tagName: string) {
    super(tagName);
  }

  public addTextTrack() {}

  public captureStream() {}

  public fastSeek() {}

  public load() {}

  public pause() {}

  public play() {}
}
